import React, { useState, useRef } from "react";
import "./index.scss";
import { useOutsideAlerter } from "../../helpers";
import { getPlayers } from "../../services/players";
import { MT, WT, VT, WCT, JT, BT } from "../../helpers/constants/circuitCodes";
import { headToHead as errors } from "../../helpers/errors/index";

interface H2HPlayer {
  familyName: string;
  givenName: string;
  playerNationalityCode: string;
  playerId: any;
  profileImage: string;
}

interface HeadToHeadProps {
  gender: string;
  playerA: H2HPlayer;
  playerB: H2HPlayer;
  categoryCode: MT | WT | WCT | VT | JT | BT;
  allPlayersLink: {
    name: string;
    url: string;
  };
}

const HeadToHead = (props: HeadToHeadProps) => {
  const { playerA, categoryCode, gender } = props;
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [playerData, setPlayerData] = useState<H2HPlayer[]>([]);
  const [inputValue, setInputValue] = useState("");
  const [isError, setIsError] = useState(false);
  const [h2hLinkBase, setH2hLinkBase] = useState();

  const hideDD = () => setIsDropdownVisible(false);
  const dropdownRef = useRef(null);

  const fetchData = async (inputValue: string) => {
    setIsError(false);
    try {
      const result = await getPlayers(inputValue, categoryCode, gender);
      setPlayerData(result.players);
      setH2hLinkBase(result.headToHeadLink.url);
    } catch (error) {
      setIsError(true);
    }
  };

  useOutsideAlerter({
    ref: dropdownRef,
    condition: true,
    callback: hideDD
  });

  return (
    <div className="head-to-head">
      <span className="vs-text">vs</span>
      <div className="head-to-head__container">
        <br />
        <div>
          <h2>Head to head</h2>
          <p>
            Select a player to compare to {playerA.givenName}{" "}
            {playerA.familyName}
          </p>
          <div className="head-to-head__player-search">
            <div className="head-to-head__player-search-inner">
              <div className="search-component search-component--inverted search-component--improved">
                <input
                  onChange={e => {
                    setInputValue(e.target.value);
                    if (e.target.value.length >= 3) {
                      if (!isDropdownVisible) {
                        setIsDropdownVisible(true);
                      }
                      fetchData(e.target.value);
                    } else if (e.target.value.length < 3 && isDropdownVisible) {
                      setIsDropdownVisible(false);
                    }
                    // put go button back to disabled state
                    if (e.target.value.length === 0) {
                      setH2hLinkBase(undefined);
                    }
                  }}
                  type="text"
                  value={inputValue}
                  placeholder="Search for player"
                />
              </div>
              {isDropdownVisible ? (
                <div
                  ref={dropdownRef}
                  className="head-to-head__suggested-players"
                >
                  <ul className="dropdown__list">
                    {playerData.map((player: H2HPlayer, index) => {
                      let playerMarkup = null;
                      if (player.playerId !== playerA.playerId) {
                        playerMarkup = (
                          <li className="dropdown__list-item" key={index}>
                            <button
                              onClick={e => {
                                e.preventDefault();
                                setInputValue(
                                  `${player.givenName} ${player.familyName}`
                                );
                                window.location.assign(
                                  `${h2hLinkBase}?player1Id=${playerA.playerId}&player2Id=${player.playerId}&circuitCode=${categoryCode}`
                                );
                              }}
                            >
                              {player.givenName} {player.familyName}
                            </button>
                          </li>
                        );
                      }
                      return playerMarkup;
                    })}
                  </ul>
                </div>
              ) : null}
              {isError ? (
                <p className="error-text">{errors.noPlayers}</p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeadToHead;
